<template>
  <AdminFooter v-if="showAdminUI" />
  <SiteFooter v-else />
</template>

<script>
import AdminFooter from '@/ui/structure/adminFooter'
import SiteFooter from '@/ui/structure/siteFooter'

export default {
  name: 'FooterWrapper',
  components: {
    AdminFooter,
    SiteFooter
  },
  computed: {
    showAdminUI () {
      return this.$route.meta.requiresAdmin || false
    }
  }
}
</script>
